module.exports = __webpack_public_path__ + "img/huodong1.936eb276.png";